<template>
  <div>
    <h6>Kham khảo tài liệu hướng dẫn sử dụng</h6>
    <ul>
      <li><i class='bx bx-right-arrow-alt' ></i> <router-link :to="{ name: 'docs-embed' }">Hướng dẫn nhúng CPD</router-link></li>
      <li><i class='bx bx-right-arrow-alt' ></i> <router-link :to="{ name: 'docs-ref' }">Ref là gì?</router-link></li>
    </ul>
  </div>
</template>

<style lang="scss" scoped>
ul {
    list-style: none !important;
    padding: 0.5rem;
    border: 1px solid var(--color-container-border);
    background-color: var(--color-container-bg);

    li{
        display: flex;
        align-items: center;
        
        a{
            font-size: 1.1rem;
            line-height: 2rem;
            text-decoration: underline;
        }
    
        i {
            font-size: 1.5rem;
        }
    }
}
</style>